import { styled } from '@mui/material';
import BRAND_LOGO from 'src/assets/logo.svg';
import VENDOR_BRAND_LOGO from 'src/assets/logoVMC.svg';
import { ThemeAwareLogo } from 'src/lib/components/ThemeAwareLogo';

const Wrapper = styled('div')`
    text-align: center;
    margin-bottom: 48px;
`;

interface Props {
    vendor?: boolean;
}

export const VendorLogo = () => (
    <Wrapper>
        <ThemeAwareLogo src={VENDOR_BRAND_LOGO} alt="ResQ" tintInDarkMode style={{ height: 36 }} />
    </Wrapper>
);

export const ClientLogo = () => (
    <Wrapper>
        <ThemeAwareLogo src={BRAND_LOGO} alt="ResQ" tintInDarkMode style={{ height: 36 }} />
    </Wrapper>
);

const BrandLogo = ({ vendor }: Props) => {
    if (vendor) {
        return <VendorLogo />;
    }
    return <ClientLogo />;
};

export default BrandLogo;
